import { request } from 'src/api/request';

interface RolesResponse {
  results: MedScout.Role[];
}

export const getRoles = async ({
  companyId,
}: {
  companyId: string;
}): Promise<RolesResponse> => {
  return await request({
    url: `v1/accounts/companies/${companyId}/roles/`,
    method: 'GET',
  });
};

export const createRole = async ({
  companyId,
  data,
}: {
  companyId: string;
  data: MedScout.Role;
}) => {
  return await request({
    url: `v1/accounts/companies/${companyId}/roles/`,
    method: 'POST',
    data,
  });
};

export const updateRole = async ({
  companyId,
  roleId,
  data,
}: {
  companyId: string;
  roleId: string;
  data: MedScout.Role;
}) => {
  return await request({
    url: `v1/accounts/companies/${companyId}/roles/${roleId}/`,
    method: 'PATCH',
    data,
  });
};

export const deleteRole = async ({
  companyId,
  roleId,
}: {
  companyId: string;
  roleId: string;
}) => {
  return await request({
    url: `v1/accounts/companies/${companyId}/roles/${roleId}/`,
    method: 'DELETE',
  });
};

// Permissions

export const getAllPermissions = async () => {
  return await request({
    url: `v1/admin/permissions/`,
    method: 'GET',
  });
};

export const getSecurityPermissions = async ({
  companyId,
  userId,
}: {
  companyId: string;
  userId: string;
}) => {
  return await request({
    url: `v1/accounts/companies/${companyId}/users/${userId}/permissions/`,
    method: 'GET',
  });
};

export const updateSecurityPermissions = async ({
  companyId,
  userId,
  data,
}: {
  companyId: string;
  userId: string;
  data: { permissions: string[] };
}) => {
  return await request({
    url: `v1/accounts/companies/${companyId}/users/${userId}/permissions/`,
    method: 'POST',
    data,
  });
};
